export function isWholePositiveNumber(value: any): boolean {
  // Returns true if the given value matches a regex for a whole number.
  return /^\d+$/.test(value);
}

export const isNumeric = (value: any): boolean =>
  // Returns true if the given value is a finite number
  !Number.isNaN(parseFloat(value)) && Number.isFinite(value);
